import { Button } from "primereact/button"
import { Panel } from "primereact/panel"
import Group from "./Group"
import { OrderList } from "primereact/orderlist"
import styles from "../../../styles/Participant-GPRA.module.css"

const Matrix = ({
  item,
  setAdditionalQuestionToDelete,
  setAdditionalEditing,
  disabled,
  setShowAddAdditional,
  setGroupToDelete,
  setShowAddGroup,
  setGroupEditing,
  setMatrixEditing,
  setMatrixToDelete,
  setShowAddMatrix,
  questions,
  updateQuestions,
  blocked,
  setShowConfirm,
}) => {
  const template = (options) => {
    const toggleIcon = options.collapsed ? "pi pi-plus" : "pi pi-minus"
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "30px 550px 100px 100px 100px 100px 90px 200px",
          gridTemplateRows: "auto auto",
          columnGap: "50px",
          rowGap: "5px",
          fontWeight: "600",
          paddingLeft: "1rem",
          paddingBottom: "1rem",
          paddingTop: "1rem",
          marginBottom: "5px",
          backgroundColor: "#efefef",
          width: "100%",
        }}
      >
        <div>Number</div>
        <div>Title</div>
        <div>Enabled</div>
        <div>Expanded</div>
        <div></div>
        <div></div>
        <div></div>
        <div
          style={{
            gridRowStart: "1",
            gridRowEnd: "3",
            gridColumnStart: "8",
            gridColumnEnd: "9",
          }}
        >
          <div style={{ display: "flex", marginTop: "0.5rem" }}>
            <div style={{ marginLeft: "2rem", marginRight: "2rem" }}>
              <Button
                disabled={disabled || blocked}
                onClick={() => {
                  if (!blocked) {
                    setMatrixEditing({
                      id: item.id,
                      organizationUuid: item.organizationUuid,
                      form: item.form,
                      section: item.section,
                      title: item.title,
                      oldTitle: item.title,
                      enabled: item.enabled,
                      required: item.required,
                      expanded: item.expanded,
                      number: item.number,
                      organizations: item.organizations,
                      editing: true,
                      selectedOrganizations: item.selectedOrganizations,
                      questionGroups: item.questionGroups,
                    })
                    setShowAddMatrix(true)
                  } else {
                    setShowConfirm(true)
                  }
                }}
                icon="pi pi-pencil"
                style={{ marginRight: "30px" }}
              />
              <Button
                disabled={
                  disabled ||
                  (item.questionGroups && item.questionGroups?.length !== 0) ||
                  blocked
                }
                onClick={() => {
                  if (!blocked) {
                    setMatrixToDelete(item)
                  } else {
                    setShowConfirm(true)
                  }
                }}
                icon="pi pi-times"
                style={{ backgroundColor: "red" }}
              />
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              <Button
                className={options.togglerClassName}
                onClick={options.onTogglerClick}
              >
                <span
                  className={toggleIcon}
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    fontSize: "20px",
                  }}
                ></span>
              </Button>
            </div>
          </div>
        </div>
        <div className={styles.lighter} style={{ marginLeft: "5px" }}>
          {item.number}
        </div>
        <div className={styles.lighter}>{item.title}</div>
        <div className={styles.lighter}>{item.enabled ? "Yes" : "No"}</div>
        <div className={styles.lighter}>{item.expanded ? "Yes" : "No"}</div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    )
  }
  const groupTemplate = (item) => {
    return (
      <Group
        group={item}
        setAdditionalQuestionToDelete={setAdditionalQuestionToDelete}
        setAdditionalEditing={setAdditionalEditing}
        disabled={disabled}
        setShowAddAdditional={setShowAddAdditional}
        setGroupToDelete={setGroupToDelete}
        setShowAddGroup={setShowAddGroup}
        setGroupEditing={setGroupEditing}
        updateQuestions={updateQuestions}
        questions={questions}
        blocked={blocked}
        setShowConfirm={setShowConfirm}
      />
    )
  }
  const setNumbers = (values) => {
    let index = 0
    const newValues = values?.map((value) => {
      const newValue = { ...value, groupOrder: index + 1 }
      index = index + 1
      return newValue
    })
    const updatedGroups = questions?.groups.map((a) => {
      let newValue = { ...a }
      const updated = newValues?.find((v) => v.title === a.title)
      if (updated) {
        newValue = updated
      }
      return newValue
    })
    updateQuestions({
      ...questions,
      groups: updatedGroups.sort((a, b) => {
        return a.groupOrder - b.groupOrder
      }),
    })
  }
  return (
    <Panel className="custom-panel" headerTemplate={template} toggleable>
      {item?.questionGroups?.length > 0 ? (
        <OrderList
          value={item?.questionGroups?.sort((a, b) => {
            return a.groupOrder - b.groupOrder
          })}
          itemTemplate={groupTemplate}
          dataKey="title"
          onChange={(e) => {
            if (!blocked) {
              setNumbers(e.value)
            } else {
              setShowConfirm(true)
            }
          }}
        ></OrderList>
      ) : (
        <div>No groups available</div>
      )}
    </Panel>
  )
}
export default Matrix
